import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import localize from "../../util/localizeUtils";
import SavedItem from "./SavedItem";
import LoadingIndicator from "../LoadingIndicator";

const Contain = styled.div`
  display: flex;
  flex-flow: row wrap;
  overflow-x: hidden;
  overflow: auto;
  background-color: ${props => props.theme.background};
  height: 100%;
  width: 100%;
  align-content: flex-start;
`;

const EmptyList = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.text.disabled};
  font-size: 15px;
  font-weight: bold;
`;

class SavedItemsList extends Component {
  renderEmpty = () => <EmptyList>{localize("emptyFolderText")}</EmptyList>;

  render() {
    const {
      savedItems,
      selectedFolder,
      onItemDoubleClick,
      onItemClick,
      savedItemsLoading,
      selectedItemId
    } = this.props;

    const savedItemsList = savedItems
      .filter(x => x.folderId === selectedFolder)
      .map(item => (
        <SavedItem
          key={item.id}
          id={item.id}
          thumbnailUrl={item.mosObject.thumbnailUrl}
          title={item.mosObject.templateTitle || item.mosObject.mosObjectId}
          abstract={item.mosObject.abstract}
          onClick={onItemClick}
          onDoubleClick={onItemDoubleClick}
          selected={item.id === selectedItemId}
        />
      ));

    return (
      <Contain>
        <LoadingIndicator visible={savedItemsLoading} />
        {savedItemsList.length > 0 ? savedItemsList : this.renderEmpty()}
      </Contain>
    );
  }
}

SavedItemsList.defaultProps = {
  savedItems: [],
  selectedFolder: null,
  onItemClick: () => {},
  onItemDoubleClick: () => {},
  selectedItemId: null
};

SavedItemsList.propTypes = {
  // ToDo: Create actual proptypes
  savedItems: PropTypes.arrayOf(PropTypes.any),
  selectedFolder: PropTypes.number,
  onItemClick: PropTypes.func,
  onItemDoubleClick: PropTypes.func,
  savedItemsLoading: PropTypes.bool.isRequired,
  selectedItemId: PropTypes.number
};

const mapStateToProps = state => ({
  savedItems: state.savedItems.savedItems,
  selectedFolder: state.savedItems.selectedFolder,
  savedItemsLoading: state.savedItems.savedItemsLoading
});

export default connect(mapStateToProps)(SavedItemsList);



// WEBPACK FOOTER //
// ./app/components/SavedItems/SavedItemsList.js